// extracted by mini-css-extract-plugin
export default {"grid":"client-form_grid__RDJvh","error":"client-form_error__8flGR","bottom":"client-form_bottom__K5RXs"};